import { render, staticRenderFns } from "./SDCardLanguage.vue?vue&type=template&id=18c66bf2&scoped=true&"
import script from "./SDCardLanguage.vue?vue&type=script&lang=js&"
export * from "./SDCardLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SDCardLanguage.vue?vue&type=style&index=0&id=18c66bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c66bf2",
  null
  
)

export default component.exports